import * as React from 'react'
import styled from 'styled-components'
import * as constants from '../../static/constants'
import InputLabel from './InputLabel'
import classNames from 'classnames'

interface IProps {
  name: string
  value?: string
  defaultValue?: string
  label?: null | string
  placeholder?: null | string
  error?: null | string
  customMessage?: null | string
  required?: boolean
  disabled?: boolean
  readonly?: boolean
  maxLength?: number
  resizable?: boolean
  highlight?: boolean
  className?: string
  onChangeHandler?(event: any): void | Promise<void>
  onBlurHandler?(event: any): void | Promise<void>
}

const InputTextAreaHighlightable: React.FC<IProps> = props => {
  const initialValueFromProps = props.defaultValue ?? props.value
  const [localValue, setLocalValue] = React.useState<string>(initialValueFromProps ?? '')

  React.useEffect(() => {
    if (props.value !== null && props.value !== undefined) {
      setLocalValue(props.value)
    }
  }, [props.value])

  return (
    <InputTextAreaWrapper className="InputTextArea">
      {props.label && <InputLabel label={props.label} required={props.required} />}
      <div className="InputTextArea_Main">
        <textarea
          className={classNames(props.className, {
            noResize: !props.resizable,
            highlight: props.highlight,
          })}
          name={props.name}
          placeholder={props.placeholder}
          required={props.required ? true : false}
          disabled={props.disabled}
          readOnly={props.readonly || false}
          maxLength={props.maxLength}
          value={localValue}
          onChange={event => {
            setLocalValue(event.target.value)
            if (typeof props.onChangeHandler === 'function') {
              props.onChangeHandler(event)
            }
          }}
          onBlur={event => {
            setLocalValue(event.target.value)
            if (typeof props.onBlurHandler === 'function') {
              props.onBlurHandler(event)
            }
          }}
        />
        {props.customMessage && (
          <span className="InputTextArea_CustomMessage">{props.customMessage}</span>
        )}
        {props.error && <span className="InputTextArea_Error">{props.error}</span>}
      </div>
    </InputTextAreaWrapper>
  )
}

const InputTextAreaWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    flex-direction: column;
  }

  textarea {
    display: block;
    width: 100%;
    height: 160px;
    padding: 8px 12px;
    border: solid 1px ${constants.COLORS.divider};
    border-radius: 4px;
    font-size: 14px;
    transition: border 0.2s ease;
    outline: none;
    background: none;
    line-height: 1.5;

    &:focus {
      border: solid 1px ${constants.COLORS.primary};
    }

    &:read-only,
    &:disabled {
      background-color: ${constants.COLORS.divider};
    }

    &.noResize {
      resize: none;
    }

    &.highlight {
      background-color: ${constants.COLORS.infoBG3};
      border-color: ${constants.COLORS.infoBorder3};
    }
  }

  .InputTextArea_Main {
    width: 100%;
    flex: 1;
  }

  .InputTextArea_CustomMessage {
    display: block;
    margin-top: 8px;
    color: ${constants.COLORS.info3};
    font-size: 12px;
    font-weight: 700;
  }

  .InputTextArea_Error {
    display: block;
    margin-top: 8px;
    color: ${constants.COLORS.cautionText};
    font-size: 14px;
  }
`

export default InputTextAreaHighlightable
